/** Soft section backgrounds for the entity scope picker (full section including options). */
export const ENTITY_SCOPE_SECTION_BG: Record<string, string> = {
    NATION: "#F8FAFE",
    DISTRICT: "#F7FBFA",
    CHURCH: "#FFFCF7",
};

/** Group header labels shown in the entity scope picker (uppercase, bold via CSS). */
export const ENTITY_SCOPE_SECTION_HEADERS: Record<string, string> = {
    NATION: "NATION",
    DISTRICT: "DISTRICTS",
    CHURCH: "CHURCHES",
};

/** Thick gray divider between entity scope sections. */
export const ENTITY_SCOPE_SECTION_DIVIDER_CLASS = "ntcog-entity-scope-divider";

/** CSS class applied to entity-scope SearchableListPicker menus. */
export const ENTITY_SCOPE_PICKER_VARIANT_CLASS = "ntcog-entity-scope-picker";

/** Closed toggle class when the picker is fused into a search bar leading control. */
export const ENTITY_SCOPE_TOGGLE_CLASS = "ntcog-entity-scope-toggle";

/** Outer wrap class so the fused search leading control stretches full width. */
export const ENTITY_SCOPE_PICKER_WRAP_CLASS = "ntcog-entity-scope-picker-wrap";

export const ENTITY_SCOPE_WORD: Record<string, string> = {
    NATION: "nation",
    DISTRICT: "district",
    CHURCH: "church",
};

export interface EntityScopeDestination {
    scope: string;
    scopeRefId: number;
}

/**
 * Prefix label for an entity (e.g. "Nation: Jamaica").
 */
export function formatEntityScopeLabel(scope: string, name: string): string {
    const normalized = scope.toUpperCase();
    if (normalized === "NATION") return `Nation: ${name}`;
    if (normalized === "DISTRICT") return `District: ${name}`;
    if (normalized === "CHURCH") return `Church: ${name}`;
    return name;
}

/**
 * Church row / closed-toggle district hint using the stored district name as-is.
 */
export function formatChurchDistrictSublabel(districtName: string): string {
    return `(District: ${districtName})`;
}

/**
 * Encodes destination as SCOPE:id so nation id 3 and district id 3 stay distinct.
 */
export function encodeEntityScopeDestination(scope: string, scopeRefId: number): string {
    return `${scope}:${scopeRefId}`;
}

/**
 * Parses encodeEntityScopeDestination values. Returns null if malformed.
 */
export function parseEntityScopeDestination(value: string | number): EntityScopeDestination | null {
    const raw = String(value);
    const colon = raw.indexOf(":");
    if (colon <= 0) return null;
    const scope = raw.slice(0, colon).toUpperCase();
    const scopeRefId = Number(raw.slice(colon + 1));
    if (!scope || !Number.isFinite(scopeRefId) || scopeRefId <= 0) return null;
    if (!ENTITY_SCOPE_WORD[scope]) return null;
    return { scope, scopeRefId };
}
